/**
 * Panel types
 */
enum PanelType {
  FPS = 0,
  MS = 1,
  MEMORY = 2,
}

export { PanelType };
